import type { GQL } from "@binale-tech/shared";
import { canBeZeroFields } from "@dms/configs/constants";

export const convertDocumentToUpdateInput = (source: GQL.IDocument): GQL.IDocumentUpdateInput => {
    const document = { ...source };
    delete (document as unknown as { status: unknown }).status;
    delete (document as Partial<GQL.IDocument>).externalReference;
    delete (document as Partial<GQL.IDocument>).updatedAt;
    delete (document as Partial<GQL.IDocument>).createdAt;
    delete (document as Partial<GQL.IDocument>).createdBy;
    delete (document as any).updatedBy;
    delete (document as Partial<GQL.IDocument>).fileName;
    delete (document as Partial<GQL.IDocument>).previewUrl;
    delete (document as Partial<GQL.IDocument>).hasXRechnung;
    delete (document as Partial<GQL.IDocument>).hasMarkdown;
    delete (document as Partial<GQL.IDocument>).numPages;
    delete (document as Partial<GQL.IDocument>).fileSize;
    delete (document as Partial<GQL.IDocument>).aiStatus;
    delete (document as any).aiBackgroundProcessingResult;
    delete (document as any).fileUrl;
    delete (document as any).year;
    // `review` (Freigabe) is intentionally kept: it is now an editable form
    // field persisted through the `documentsUpdate` path (FIBU-885).
    delete (document as Partial<GQL.IDocument>).paymentStatus;
    // DMS-706: the thread marker is server-owned; a stale bundle without this line breaks every save.
    delete (document as Partial<GQL.IDocument>).notesColor;
    // Bewirtung has its own mutations; DocumentUpdateInput no longer carries it.
    delete (document as Partial<GQL.IDocument>).bewirtung;

    Object.keys(document).forEach((key: keyof GQL.IDocumentUpdateInput) => {
        if (canBeZeroFields.includes(key)) {
            const value = document[key] || document[key] === 0 ? document[key] : null;
            document[key] = value as never;
        } else {
            const value = document[key] ? document[key] : null;
            document[key] = value as never;
        }
    });

    return document;
};
